import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AboutRoutingModule } from './about-routing.module';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    AboutRoutingModule
  ]
})
export class AboutModule { }
